export default __webpack_public_path__ + "static/media/logo2-dark-vertical.1b419254.svg";